"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoilEnhancers = void 0;
var Tags_1 = require("../../Tags");
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var TileType_1 = require("../../../TileType");
var CardName_1 = require("../../../CardName");
var Resources_1 = require("../../../Resources");
var DeferredAction_1 = require("../../../deferredActions/DeferredAction");
var GainResources_1 = require("../../../deferredActions/GainResources");
var CardRenderer_1 = require("../../render/CardRenderer");
var SpaceType_1 = require("../../../SpaceType");
var Size_1 = require("../../render/Size");
var SoilEnhancers = (function (_super) {
    __extends(SoilEnhancers, _super);
    function SoilEnhancers() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.SOIL_ENHANCERS,
            tags: [Tags_1.Tags.MICROBE],
            cost: 7,
            metadata: {
                description: 'Every time you place a non-ocean tile ON MARS, gain 1 plant.',
                cardNumber: 'L420',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect(undefined, function (be) { return be.emptyTile('normal', Size_1.Size.SMALL).asterix().startEffect.plants(1); }).br;
                }),
            },
        }) || this;
    }
    SoilEnhancers.prototype.onTilePlaced = function (cardOwner, activePlayer, space) {
        var _this = this;
        var _a;
        if (cardOwner.id === activePlayer.id && ((_a = space.tile) === null || _a === void 0 ? void 0 : _a.tileType) !== TileType_1.TileType.OCEAN && space.spaceType !== SpaceType_1.SpaceType.COLONY) {
            cardOwner.game.defer(new GainResources_1.GainResources(cardOwner, Resources_1.Resources.PLANTS, {
                count: 1,
                cb: function () { return activePlayer.game.log('${0} gained 1 ${1} from ${2}', function (b) { return b.player(cardOwner).string(Resources_1.Resources.PLANTS).cardName(_this.name); }); },
            }), cardOwner.id !== activePlayer.id ? DeferredAction_1.Priority.OPPONENT_TRIGGER : undefined);
        }
    };
    SoilEnhancers.prototype.play = function () {
        return undefined;
    };
    return SoilEnhancers;
}(Card_1.Card));
exports.SoilEnhancers = SoilEnhancers;
//# sourceMappingURL=SoilEnhancers.js.map